import {
  _THEME,
  accentColor,
  errorColor,
  grey1,
  grey3,
  grey4,
  grey5,
  grey6,
  lg1,
  lg2,
  lg3,
  mainColor,
  mainColor2,
  mainColor3,
  md1,
  md2,
  md3,
  mobileQuery,
  sm1,
  sm2,
  sm3,
  tabQuery,
  white,
} from "../../theme";

export const _STYLES = {
  container: {
    maxWidth: "100%",
    margin: "0 auto",
    padding: "0 1rem",
    "@media (min-width: 476px)": {
      width: "100%",
    },
    " @media (min-width: 768px)": {
      width: 750,
    },
    "@media (min-width: 992px)": {
      width: 970,
    },
    "@media (min-width: 1200px)": {
      width: "95%",
      maxWidth: 1400,
    },
  },
  mainColor: _THEME.color.primary.main,
  customFont: {
    fontFamily: "Share Tech Mono, sans-serif !important",
    textTransform: "uppercase",
    letterSpacing: 4,
    fontWeight: 600,
  },
  mainHeader: {
    fontSize: lg2,
    lineHeight: 1.3,
    [tabQuery]: {
      fontSize: md3,
    },
    [mobileQuery]: {
      fontSize: md2,
    },
  },
  sectionHeader: {
    fontSize: lg1,
    [tabQuery]: {
      fontSize: md2,
    },
    [mobileQuery]: {
      fontSize: md1,
    },
    lineHeight: 1.3,
  },
  miniHeader: {
    fontSize: md1,
    [tabQuery]: {
      fontSize: sm3,
    },
    [mobileQuery]: {
      fontSize: sm2,
    },
    lineHeight: 1.3,
  },
  normalHeader: {
    fontSize: md1,
    [tabQuery]: {
      fontSize: sm3,
    },
    [mobileQuery]: {
      fontSize: sm2,
    },
    lineHeight: 1.3,
    fontWeight: 400,
  },
  filterHeader: {
    fontSize: sm3,
    [tabQuery]: {
      fontSize: sm2,
    },
    [mobileQuery]: {
      fontSize: sm1,
    },
    fontWeight: 400,
  },
  subHeader: {
    fontSize: md3,
    [tabQuery]: {
      fontSize: md1,
    },
    [mobileQuery]: {
      fontSize: sm3,
    },
  },
  colorPrimary: {
    color: mainColor,
  },
  colorError: {
    color: errorColor,
  },
  colorText: {
    color: grey4,
  },
  colorSubText: {
    color: grey5,
  },
  padTopXl: {
    paddingTop: 120,
    [tabQuery]: {
      paddingTop: 60,
    },
  },
  padTopLg: {
    paddingTop: 90,
    [tabQuery]: {
      paddingTop: 40,
    },
  },
  padTopMd: {
    paddingTop: 60,
    [tabQuery]: {
      paddingTop: 40,
    },
  },
  padTopSm: {
    paddingTop: 40,
    [tabQuery]: {
      paddingTop: 20,
    },
  },
  padBottomXl: {
    paddingBottom: 120,
    [tabQuery]: {
      paddingBottom: 60,
    },
  },
  padBottomLg: {
    paddingBottom: 90,
    [tabQuery]: {
      paddingBottom: 40,
    },
  },
  padBottomMd: {
    paddingBottom: 60,
    [tabQuery]: {
      paddingBottom: 40,
    },
  },
  padBottomSm: {
    paddingBottom: 40,
    [tabQuery]: {
      paddingBottom: 20,
    },
  },

  paraLine: {
    lineHeight: 1.75,
  },
  headerLine: {
    lineHeight: 1.5,
  },
  textSm1: {
    fontSize: sm1,
  },
  textSm2: {
    fontSize: sm2,
    [tabQuery]: {
      fontSize: sm1,
    },
  },
  textSm3: {
    fontSize: sm3,
    [tabQuery]: {
      fontSize: sm2,
    },
    [mobileQuery]: {
      fontSize: sm1,
    },
  },
  textMd1: {
    fontSize: md1,
    [tabQuery]: {
      fontSize: sm3,
    },

    [mobileQuery]: {
      fontSize: sm2,
    },
  },
  textMd2: {
    fontSize: md2,
    [tabQuery]: {
      fontSize: md1,
    },
    [mobileQuery]: {
      fontSize: sm3,
    },
  },
  textMd3: {
    fontSize: md3,
    [tabQuery]: {
      fontSize: md2,
    },
    [mobileQuery]: {
      fontSize: md1,
    },
  },
  textLg1: {
    fontSize: lg1,
    [tabQuery]: {
      fontSize: md3,
    },
    [mobileQuery]: {
      fontSize: md2,
    },
  },
  textLg2: {
    fontSize: lg2,
    [tabQuery]: {
      fontSize: lg1,
    },
    [mobileQuery]: {
      fontSize: md3,
    },
  },
  textLg3: {
    fontSize: lg3,
    [tabQuery]: {
      fontSize: lg2,
    },
    [mobileQuery]: {
      fontSize: lg1,
    },
  },
  fontLight: {
    fontWeight: 300,
  },
  fontRegular: {
    fontWeight: 400,
  },
  fontMid: {
    fontWeight: 500,
  },
  pb0: {
    paddingBottom: "0 !important",
  },
  fontBold: {
    fontWeight: 600,
  },
  mt1: {
    marginTop: "1rem",
  },
  mt2: {
    marginTop: "2rem",
  },
  mb1: {
    marginBottom: "1rem",
  },
  mb2: {
    marginBottom: "2rem",
  },
  mb0: {
    marginBottom: 0,
  },
  logo: {
    height: 50,
    [tabQuery]: {
      height: 40,
    },
  },
  bgGrey: {
    background: grey1,
  },
  bgWhite: {
    background: grey6,
  },
  bgBlue: {
    background: mainColor2,
  },
  h100: {
    height: "100%",
  },
  textCenter: {
    textAlign: "center",
  },
  surveyImg: {
    display: "flex",
    margin: "2rem auto",
  },
  textLeft: {
    textAlign: "left",
  },
  textRight: {
    textAlign: "right",
  },
  colorLight: {
    color: "#fff",
  },
  w100: {
    width: "100%",
  },
  blockBordered: {
    border: "16px solid rgb(0 103 108 / 20%)",
  },
  bgAccent: {
    background: accentColor,
  },
  bgPrimary: {
    background: mainColor,
  },
  m0: {
    margin: 0,
  },
  mxAuto: {
    marginLeft: "auto",
    marginRight: "auto",
  },
  overflowHidden: {
    overflow: "hidden",
  },
  pRelative: {
    position: "relative",
  },
  px1: {
    paddingLeft: "1rem",
    paddingRight: "1rem",
  },
  py1: {
    paddingTop: "1rem",
    paddingBottom: "1rem",
  },
  verticalDivider: {
    textAlign: "center",
    "& > div": {
      height: "100%",
    },
  },
  modalContainer: {
    paddingTop: "1rem",
    paddingBottom: "1rem",
    overflowX: "auto",
  },
  bodyWrap: {
    height: "100vh",
  },
  dashboardContainer: {
    // background: accentColor2,
    // padding: "1rem",
  },
  dashboardInner: {
    background: white,
    borderRadius: 8,
    height: "100%",
    overflow: "hidden",
  },
  dashboardMid: {
    background: mainColor2,
    padding: "2rem",
    minHeight: "calc(100vh - 75px)",
    maxHeight: "calc(100vh - 75px)",
    overflowY: "auto",
    height: "100%",
    "& > div": {
      animation: "fade-in 0.2s cubic-bezier(0.39, 0.575, 0.565, 1) both",
    },
  },
  dashboardWrap: {
    height: "100%",
  },
  dashLeft: {
    padding: "0 0 2rem",
    background: grey6,
  },
  dashRight: {
    padding: "2rem 0",
    background: grey6,
  },
  dashHeader: {
    width: "100%",
    padding: "1rem",
    height: 75,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& svg": {
      width: 24,
      height: 24,
      fill: mainColor,
    },
  },
  segmentWrap: {
    border: `1px solid ${mainColor3}`,
  },
  fillGrey: {
    "& svg": {
      fill: grey3,
    },
  },

  mainText: {
    fontSize: sm2,
    lineHeight: 1.75,
    fontWeight: 400,
    color: grey3,
    [tabQuery]: {
      fontSize: sm1,
    },
  },

  mainTextHeader: {
    fontSize: sm3,
    lineHeight: 1.75,
    fontWeight: 500,
    color: grey3,
    [tabQuery]: {
      fontSize: sm1,
    },
  },

  subText: {
    fontSize: sm2,
    lineHeight: 1.75,
    fontWeight: 400,
    color: grey4,
    [tabQuery]: {
      fontSize: sm1,
    },
  },
  subTextHeader: {
    fontSize: sm2,
    lineHeight: 1.75,
    fontWeight: 500,
    color: grey4,
    [tabQuery]: {
      fontSize: sm1,
    },
  },
  radioCardWrap: {
    width: "100%",
    "&>.ant-radio": {
      position: "absolute",
      left: "1rem",
      zIndex: 1,
    },
    "&>span:last-of-type": {
      width: "100%",
      padding: 0,
    },
    "& .ant-card-body": {
      padding: "12px 12px 12px 24px",
      textAlign: "center",
      borderRadius: 0,
    },

    "& .ant-radio-checked": {
      border: `2px solid #fff`,
    },
    "&.ant-radio-wrapper-checked": {
      "& .ant-card-body": {
        backgroundColor: mainColor,
      },
      "& .ant-statistic-content": {
        color: white,
        fontWeight: 400,
      },
    },
  },
  radioCard: {
    borderColor: mainColor,
    "&:not(.ant-card-bordered)": {
      border: `1px solid ${grey1}`,
      //boxShadow: `${shadow1} !important`,
    },
    "& .ant-statistic-content": {
      fontSize: sm3,
    },
  },
  avatarIconBg: {
    color: "#f4b42c",
    backgroundColor: "#fefbda",
  },
  transparentBlock: {
    width: "100%",
    position: "relative",
    padding: "2rem",
    borderRadius: 16,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    background: grey6,
    border: `1px solid ${mainColor3}`,
  },
  inlineBadge: {
    display: "flex",
    alignItems: "center",
  },
  icon: {
    width: 14,
    height: 14,
  },
  link: {
    all: "unset",
    cursor: "pointer",
    "&:hover": {
      all: "unset",
      cursor: "pointer",
    },
  },
  patientPieContainer: {
    height: 318,
  },
  pieContainer: {
    height: 400,
  },
  dataCard: {
    background: grey6,
    border: `1px solid ${mainColor3}`,
    padding: "1rem 2rem",
    borderRadius: 16,
    width: "100%",
  },
  flexGrow: {
    flex: 1,
  },
  menuLoad: {
    width: "100%",
    padding: 8,
  },
  menuSkel: {
    height: 40,
    width: "100%",
    borderRadius: 8,
  },
  fixedLabel: {
    "& label": {
      width: 200,
    },
  },
  overflowY: {
    overflowY: "auto",
  },
  asterisk: {
    "&::before": {
      display: "inline-block",
      marginInlineEnd: "4px",
      color: "#ff4d4f",
      fontSize: "14px",
      fontFamily: "SimSun, sans-serif",
      lineHeight: 1,
      content: '"*"',
    },
  },
  capitalize: {
    textTransform: "capitalize",
  },
  navLogo: {
    height: 32,
    margin: "auto",
    display: "block",
  },
};
